import { EventEmitter } from 'eventemitter3';

const CHANGE_EVENT = 'change';

export default class BaseStore extends EventEmitter {

    public dispatchToken: string|undefined;

    constructor() {
        super();
        this.dispatchToken = undefined;
    }

    protected emitChange() {
        this.emit(CHANGE_EVENT);
    }

    protected getListeners() {
        return this.listeners(CHANGE_EVENT);
    }

    addChangeListener(callback: (...args: any[]) => void) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback: (...args: any[]) => void) {
        this.removeListener(CHANGE_EVENT, callback);
    }
}